/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Allocation_EnabledInputs */

const en_reference_field_allocation_enabled = /** @type {(inputs: Reference_Field_Allocation_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation enabled`)
};

/**
* | output |
* | --- |
* | "Allocation enabled" |
*
* @param {Reference_Field_Allocation_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_allocation_enabled = /** @type {((inputs?: Reference_Field_Allocation_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Allocation_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_allocation_enabled(inputs)
});